import { Injectable } from '@angular/core';
import { cacheable } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map, mapTo, tap } from 'rxjs/operators';
import { ApiService } from '../../../shared/services/core/api.service';
import { Scorecard } from '../models/scorecard.model';
import { Badges } from './badges.model';
import { BadgesStore } from './badges.store';
import { BadgesByCategory } from './badges-by-category.model';
import { BadgesV2Store } from './badgesv2.store';
import { BadgesV2Query } from './badgesv2.query';

@Injectable({ providedIn: 'root' })
export class BadgesService {
  constructor(private badgesStore: BadgesStore, private api: ApiService, private badgesv2Store: BadgesV2Store, private badgesv2Query: BadgesV2Query) { }
  /**
   * fetch the active scorecards from the api
   * and set the store.
   */
  fetchBadges() {
    const request$: Observable<null> = this.api.get<Badges>('scorecard/badges').pipe(
      tap((badges) => {
        this.badgesStore.set(badges);
      }),
      mapTo(null)
    );

    return cacheable(this.badgesStore, request$);
  }

  /**
   * Get a scorecard by id
   */
  fetchScorecardBadge(scorecardId: number) {
    const request$: Observable<Scorecard> = this.api.getAnySingle<Scorecard>('scorecard/' + scorecardId);
    return request$;
  }

  /**
   * Set a scorecard badge to be completed in the store
   */
  setBadgeToCompleted(scorecardId: number) {
    this.badgesStore.update(scorecardId, { Status: 1 });
  }

  setBadgeV2ToCompleted(scorecardId: number) {
    const categoryHasBadgeCompleted = this.badgesv2Query.getAll().find(b => b.Badges.some(badge => badge.ScorecardId == scorecardId))
    if (!categoryHasBadgeCompleted) return
    let newBadges = categoryHasBadgeCompleted.Badges;
    newBadges = newBadges.map(x => {
      if (x.ScorecardId === scorecardId) {
        return { ...x, Status: 1 }
      } else return x
    }
    )
    const id = (categoryHasBadgeCompleted as any).storeId
    this.badgesv2Store.update(id, { Badges: newBadges });

  }

  fetchBadgeV2() {
    const request$: Observable<null> = this.api.get<BadgesByCategory>('scorecard/v2/badges').pipe(
      tap((badges) => {
        this.badgesv2Store.set(badges);
      }),
      map(() => null)
    );

    return cacheable(this.badgesv2Store, request$);
  }
}
